module.exports = __webpack_public_path__ + "static/media/Manager-illustration.632e6ced.svg";